import { keyManageConstants } from "../_constants";
import { keyManageServices } from "../_services";
import { alertActions } from "./";

export const keyManageActions = {
  getAllKeys,
  getKeyManageTopCardInfo,
  createKey,
  getAllOpenAPIs,
  getOpenAPIForUser,
  getAPIKeyDetails,
  editAPIKey,
  assignOpenAPIForUser,
  applyApiKeyFilter,
  getApiKeyFilters,
  activeApiKey,
  deleteApiKey,
};

function getAllKeys(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getAllKeys(offset, limit).then(
      (keyList) => {
        dispatch(success(keyList));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.GET_ALL_KEYS_REQUEST };
  }
  function success(keyList) {
    return { type: keyManageConstants.GET_ALL_KEYS_SUCCESS, keyList };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_ALL_KEYS_FAILURE, error };
  }
}

function getKeyManageTopCardInfo() {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getKeyManageTopCardInfo().then(
      (keyTopInfo) => {
        dispatch(success(keyTopInfo));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.GET_KEY_TOP_INFO_REQUEST };
  }
  function success(keyTopInfo) {
    return { type: keyManageConstants.GET_KEY_TOP_INFO_SUCCESS, keyTopInfo };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_KEY_TOP_INFO_FAILURE, error };
  }
}

function createKey(formData) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.createKey(formData).then(
      (keyCreated) => {
        dispatch(success(keyCreated));
        dispatch(alertActions.success(keyCreated.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.CREATE_KEY_REQUEST };
  }
  function success(keyCreated) {
    return {
      type: keyManageConstants.CREATE_KEY_SUCCESS,
      keyCreated,
    };
  }
  function failure(error) {
    return { type: keyManageConstants.CREATE_KEY_FAILURE, error };
  }
}

function getAllOpenAPIs() {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getAllOpenAPIs().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.GET_ALL_OPEN_API_REQUEST };
  }
  function success(data) {
    return { type: keyManageConstants.GET_ALL_OPEN_API_SUCCESS, data };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_ALL_OPEN_API_FAILURE, error };
  }
}

function editAPIKey(formData, apiKeyManagementId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.editAPIKey(formData, apiKeyManagementId).then(
      (updatedAPI) => {
        dispatch(success(updatedAPI));
        dispatch(alertActions.success(updatedAPI.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.UPDATE_API_KEY_REQUEST };
  }
  function success(updatedAPI) {
    return { type: keyManageConstants.UPDATE_API_KEY_SUCCESS, updatedAPI };
  }
  function failure(error) {
    return { type: keyManageConstants.UPDATE_API_KEY_FAILURE, error };
  }
}

function getOpenAPIForUser(userId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getOpenAPIForUser(userId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.GET_USER_OPEN_API_REQUEST };
  }
  function success(data) {
    return { type: keyManageConstants.GET_USER_OPEN_API_SUCCESS, data };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_USER_OPEN_API_FAILURE, error };
  }
}

function getAPIKeyDetails(apiKeyManagementId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getAPIKeyDetails(apiKeyManagementId).then(
      (keyDetails) => {
        dispatch(success(keyDetails));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.GET_KEY_DETAILS_REQUEST };
  }
  function success(keyDetails) {
    return { type: keyManageConstants.GET_KEY_DETAILS_SUCCESS, keyDetails };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_KEY_DETAILS_FAILURE, error };
  }
}

function assignOpenAPIForUser(formData, userId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.assignOpenAPIForUser(formData, userId).then(
      (apiAssigned) => {
        dispatch(success(apiAssigned));
        dispatch(alertActions.success(apiAssigned.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.ASSIGN_API_REQUEST };
  }
  function success(apiAssigned) {
    return {
      type: keyManageConstants.ASSIGN_API_SUCCESS,
      apiAssigned,
    };
  }
  function failure(error) {
    return { type: keyManageConstants.ASSIGN_API_FAILURE, error };
  }
}
//applyKeyFilter
function applyApiKeyFilter(
  accessUser,
  createduser,
  isActive,
  isDeleted,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices
      .applyApiKeyFilter(
        accessUser,
        createduser,
        isActive,
        isDeleted,
        startDate,
        endDate,
        search,
        offset,
        limit
      )
      .then(
        (keyList) => {
          dispatch(success(keyList));
        },
        (error) => {
          dispatch(failure(error.toString()));
        }
      );
  };
  function request() {
    return { type: keyManageConstants.GET_ALL_KEYS_REQUEST };
  }
  function success(keyList) {
    return {
      type: keyManageConstants.GET_ALL_KEYS_SUCCESS,
      keyList,
    };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_ALL_KEYS_FAILURE, error };
  }
}
//getApiKeyFilters
function getApiKeyFilters() {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.getApiKeyFilters().then(
      (apiKeyFilters) => dispatch(success(apiKeyFilters)),
      (error) => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: keyManageConstants.GET_API_KEY_FILTERS_REQUEST };
  }
  function success(apiKeyFilters) {
    return {
      type: keyManageConstants.GET_API_KEY_FILTERS_SUCCESS,
      apiKeyFilters,
    };
  }
  function failure(error) {
    return { type: keyManageConstants.GET_API_KEY_FILTERS_FAILURE, error };
  }
}

// Activate API Key

function activeApiKey(isActive, apiKeyManagementId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.activeApiKey(isActive, apiKeyManagementId).then(
      (activateApi) => {
        dispatch(success(activateApi));
        dispatch(alertActions.success(activateApi.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: keyManageConstants.ACTIVATE_API_KEY_REQUEST };
  }
  function success(activateApi) {
    return { type: keyManageConstants.ACTIVATE_API_KEY_SUCCESS, activateApi };
  }
  function failure(error) {
    return { type: keyManageConstants.ACTIVATE_API_KEY_FAILURE, error };
  }
}

//Delete API Key

function deleteApiKey(apiKeyManagementId) {
  return (dispatch) => {
    dispatch(request());
    keyManageServices.deleteApiKey(apiKeyManagementId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: keyManageConstants.DELETE_APIKEY_REQUEST };
  }
  function success(data) {
    return { type: keyManageConstants.DELETE_APIKEY_SUCCESS, data };
  }
  function failure(error) {
    return { type: keyManageConstants.DELETE_APIKEY_FAILURE, error };
  }
}
